import Global from "./Global";
import { addDelegatedEventListener } from "./helpers/events";
import { createFocusTrap } from "focus-trap";

const Modal = {
  elements: {},
  focusTrap: null,
  focusTrapElement: null,
  bodyWrapper: null,

  init: () => {
    Modal.elements.modal = document.querySelector(".modal");

    if (!Modal.elements.modal) {
      return;
    }

    Modal.elements.content =
      Modal.elements.modal.querySelector(".modal__content");

    addDelegatedEventListener(
      "click",
      ".modal__overlay, .modal__close",
      Modal.close
    );

    addDelegatedEventListener("click", "[data-modal]", (e) => {
      e.preventDefault();

      Modal.open(e.target.dataset.modalId);
    });

    // key up listener
    window.addEventListener("keyup", (e) => {
      // close modal on esc key
      if (e?.key === "Escape" || e?.key === "Esc" || e?.keyCode === 27) {
        Modal.close();
      }
    });

    // set focus trap element
    Modal.focusTrapElement = document.getElementById("modal");

    // set body wrapper element
    Modal.bodyWrapper = document.querySelector(".wrapper");

    // Initialize focus trap
    if (Modal.focusTrapElement) {
      Modal.focusTrap = createFocusTrap("#modal", {
        onActivate: () => Modal.focusTrapElement.classList.add("is-active"),
        onDeactivate: () =>
          Modal.focusTrapElement.classList.remove("is-active"),
      });
    }
  },
  show: () => {
    if (Modal.elements.modal) {
      Modal.elements.modal.classList.add("modal--is-open");

      // activate focus trap!
      Modal.focusTrap.activate();

      // set inert attribute to body wrapper to disable focus on page content
      if (Modal.bodyWrapper) Modal.bodyWrapper.setAttribute("inert", "");
    }
  },
  hide: () => {
    if (Modal.elements.modal) {
      Modal.elements.modal.classList.remove("modal--is-open");
    }
  },
  setContent: (content) => {
    if (Modal.elements.content) {
      Modal.elements.content.innerHTML = content;
    }
  },
  open: (modalId) => {
    const element = document.getElementById(modalId);

    if (element) {
      Modal.setContent(element.innerHTML);
    }

    Modal.show();

    // focus login username input field
    //Global.focusUsernameInput();
  },
  close: () => {
    Modal.setContent("");
    Modal.hide();

    // remove inert attribute on body wrapper to re-enable focus on page content
    if (Modal.bodyWrapper) Modal.bodyWrapper.removeAttribute("inert");

    // deactivate focus trap!
    Modal.focusTrap.deactivate();
  },
};

export default Modal;
